import React from "react";
import { Grid } from "@mui/material";
import PotentialProjectTabs from "../../containers/PotentialProjectTabs";
import { dialogBoxRef } from "../../../base/components/ContentRouter";
import PipelineProjects from "../../../project/containers/PipelineProjects";
import PledgeStatus from "../PledgeStatus";

interface IProps {
  data: any;
  projectParams: string;
  totalDisbursment: number;
}

const MidTable = (props: IProps) => {
  const gridHeight = "20%";
  const rowHeight = "55%";
  const fontSize = "1.2rem";
  return (
    <Grid container spacing={2} sx={{ height: "100%" }}>
      <Grid item xs={12} sx={{ height: gridHeight }}>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            background: "#23AD52",
            textAlign: "center",
            color: "white",
            fontSize: fontSize,
            fontFamily: "Cousine",
            fontWeight: "500",
            wordWrap: "break-word",
            boxShadow: "0px 3px 4px 3px rgba(0, 0, 0, 0.25)",
            borderRadius: 5,
          }}
        >
          <a
            href={`/projects?${props.projectParams}`}
            style={{ color: "white" }}
          >
            SIGNED
          </a>
        </div>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            display: "flex",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.signed["no_of_project"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.signed["amount"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.signed["disbursed"] < props.totalDisbursment &&
            props.data?.total["no_of_project"] > 20
              ? props.totalDisbursment.toFixed(2)
              : props.data?.signed["disbursed"]}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.signed["withdrawal_amount"] || 0}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ height: gridHeight }}>
        <div
          style={{
            width: "100%",
            height: "!0%",
            background: "#E5AA13",
            textAlign: "center",
            color: "white",
            fontSize: fontSize,
            fontFamily: "Cousine",
            fontWeight: "500",
            wordWrap: "break-word",
            boxShadow: "0px 3px 4px 3px rgba(0, 0, 0, 0.25)",
            borderRadius: 5,
          }}
        >
          <a
            href={`#`}
            style={{ color: "white" }}
            onClick={() => {
              dialogBoxRef?.current?.setContent(
                <>
                  <PipelineProjects />
                </>,
              );
              dialogBoxRef?.current?.openDialog("Pipeline Project Information");
            }}
          >
            PIPELINE
          </a>
        </div>
        <div
          style={{ width: "100%", height: "!0%", display: "flex", flexGrow: 1 }}
        >
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#E5AA13",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.pipeline["no_of_project"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#E5AA13",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.pipeline["amount"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#E5AA13",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.pipeline["disbursed"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#E5AA13",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.pipeline["withdrawal_amount"] || 0}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ height: gridHeight }}>
        <div
          style={{
            width: "100%",
            height: "!0%",
            background: "#100F0F",
            textAlign: "center",
            color: "white",
            fontSize: fontSize,
            fontFamily: "Cousine",
            fontWeight: "500",
            wordWrap: "break-word",
            boxShadow: "0px 3px 4px 3px rgba(0, 0, 0, 0.25)",
            borderRadius: 5,
          }}
        >
          <a
            href={`#`}
            style={{ color: "white" }}
            //    onClick={() => {
            //        dialogBoxRef?.current?.setContent(<><PledgeStatus/></>)
            //        dialogBoxRef?.current?.openDialog("Pipeline Project Information")

            //    }}
          >
            TOTAL
          </a>
        </div>
        <div
          style={{ width: "100%", height: "!0%", display: "flex", flexGrow: 1 }}
        >
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#100F0F",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.total["no_of_project"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#100F0F",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.total["amount"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#100F0F",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.total["disbursed"] < props.totalDisbursment &&
            props.data?.total["no_of_project"] > 20
              ? props.totalDisbursment.toFixed(2)
              : props.data?.signed["disbursed"]}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#100F0F",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.total["withdrawal_amount"] || 0}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ height: gridHeight }}>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            background: "#7481A4",
            textAlign: "center",
            color: "white",
            fontSize: fontSize,
            fontFamily: "Cousine",
            fontWeight: "500",
            wordWrap: "break-word",
            boxShadow: "0px 3px 4px 3px rgba(0, 0, 0, 0.25)",
            borderRadius: 5,
          }}
        >
          <a
            href={`#`}
            style={{ color: "white" }}
            onClick={() => {
              dialogBoxRef?.current?.setContent(
                <>
                  <PotentialProjectTabs isEAD={false} />
                </>,
              );
              dialogBoxRef?.current?.openDialog(
                "Potential Project Information",
              );
            }}
          >
            POTENTIAL PROJECT SHARED BY PROVINCES{" "}
          </a>
        </div>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            display: "flex",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#7481A4",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential["no_of_project"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#7481A4",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential["amount"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#7481A4",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential["disbursed"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#7481A4",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential["withdrawal_amount"] || 0}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ height: gridHeight }}>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            background: "#A13838",
            textAlign: "center",
            color: "white",
            fontSize: fontSize,
            fontFamily: "Cousine",
            fontWeight: "500",
            wordWrap: "break-word",
            boxShadow: "0px 3px 4px 3px rgba(0, 0, 0, 0.25)",
            borderRadius: 5,
          }}
        >
          <a
            href={`#`}
            style={{ color: "white" }}
            onClick={() => {
              dialogBoxRef?.current?.setContent(
                <>
                  <PotentialProjectTabs isEAD={true} />
                </>,
              );
              dialogBoxRef?.current?.openDialog(
                "Potential Project Information",
              );
            }}
          >
            POTENTIAL PROJECT SHARED WITH EAD
          </a>
        </div>
        <div
          style={{
            width: "100%",
            height: rowHeight,
            display: "flex",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential_ead["no_of_project"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential_ead["amount"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential_ead["disbursed"] || 0}
          </div>
          <div
            style={{
              width: "25%",
              height: "100%",
              background: "#F1EFEF",
              border: "1px #C4C2C2 solid",
              textAlign: "center",
              color: "#23AD52",
              fontSize: fontSize,
              fontFamily: "Cuprum",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {props.data?.potential_ead["withdrawal_amount"] || 0}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default MidTable;
